import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const KPIs = () => {
  return <ErpTablePage moduleKey="hrm_kpis" />;
};

export default KPIs;